<template>
  <footer class="mt-auto border-t border-edge">
    <div class="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 py-6 sm:flex-row sm:justify-between sm:px-6">
      <div class="flex gap-2.5">
        <a
          v-for="social in socials"
          :key="social.label"
          :href="social.href"
          target="_blank"
          rel="noopener noreferrer"
          :aria-label="social.label"
          class="flex h-11 w-11 items-center justify-center rounded-xl border border-edge bg-panel text-slate-100 transition-colors hover:border-beer hover:text-beer"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path v-for="d in social.paths" :key="d" :d="d" />
          </svg>
        </a>
      </div>
      <nav aria-label="Fußzeile" class="flex gap-5 text-sm">
        <RouterLink to="/rules" class="text-slate-400 hover:text-beer">Regeln</RouterLink>
        <RouterLink to="/impressum" class="text-slate-400 hover:text-beer">Impressum</RouterLink>
        <RouterLink :to="{ path: '/impressum', hash: '#datenschutz' }" class="text-slate-400 hover:text-beer">Datenschutz</RouterLink>
      </nav>
    </div>
  </footer>
</template>

<script setup lang="ts">
const socials = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/drunkenhippos/',
    paths: ['M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4z', 'M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z', 'M17.5 6.5h.01'],
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61558399793569',
    paths: ['M15 3h-3a4 4 0 0 0-4 4v3H5v4h3v7h4v-7h3l1-4h-4V7a1 1 0 0 1 1-1h3z'],
  },
  {
    label: 'Fanshop',
    href: 'https://shop.teamshirts.de/drunkenhippos/products',
    paths: ['M8 3 3 6l2 4 2-1v12h10V9l2 1 2-4-5-3a4 4 0 0 1-8 0z'],
  },
];
</script>
